import { useState, useEffect } from 'react';
import { LogsFilters } from '../types';
import { DEFAULT_FILTERS } from '../constants';

export const useLogsFilters = (initialFilters: LogsFilters) => {
    const [queryFilters, setQueryFilters] = useState<LogsFilters>({
        ...DEFAULT_FILTERS,
        ...initialFilters
    });

    useEffect(() => {
        setQueryFilters((prevFilters) => ({
            ...prevFilters,
            ...initialFilters
        }));
    }, [initialFilters]);

    return { queryFilters, setQueryFilters };
};
